<template>
  <div>
    <a-switch-field
      varName="password_policies.numbers.enabled"
      varLabel="Numbers Required"
      :varRequired="true"
      :varInitial="data.password_policies.numbers.enabled"
      :formLayout="formLayout"
      :size="size"
    />
    <a-switch-field
      varName="password_policies.characters.enabled"
      varLabel="Characters Required"
      :varRequired="true"
      :varInitial="data.password_policies.characters.enabled"
      :formLayout="formLayout"
      :size="size"
    />
    <a-number-field
      varName="password_policies.characters.min"
      varLabel="Minimum Characters"
      :varRequired="true"
      :varInitial="data.password_policies.characters.min"
      :formLayout="formLayout"
      :size="size"
      :min=8
      :max=19
    />
    <a-number-field
      varName="password_policies.characters.max"
      varLabel="Maximum Characters"
      :varRequired="true"
      :varInitial="data.password_policies.characters.max"
      :formLayout="formLayout"
      :size="size"
      :min=20
      :max=50
    />
    <a-switch-field
      varName="password_policies.lower_case.enabled"
      varLabel="Lower-case"
      :varRequired="true"
      :varInitial="data.password_policies.upper_case.enabled"
      :formLayout="formLayout"
      :size="size"
    />
    <a-switch-field
      varName="password_policies.upper_case.enabled"
      varLabel="Upper-case"
      :varRequired="true"
      :varInitial="data.password_policies.upper_case.enabled"
      :formLayout="formLayout"
      :size="size"
    />
    <a-switch-field
      varName="password_policies.special_characters.enabled"
      varLabel="Special Character"
      :varRequired="true"
      :varInitial="data.password_policies.special_characters.enabled"
      :formLayout="formLayout"
      :size="size"
    />
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  components: {

  },
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
};
</script>